import { render } from "./ReqForm.vue?vue&type=template&id=06c4bcdc"
import script from "./ReqForm.vue?vue&type=script&lang=js"
export * from "./ReqForm.vue?vue&type=script&lang=js"

import "./ReqForm.vue?vue&type=style&index=0&id=06c4bcdc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__